export function getHolidayTypeImageId(holidayType: string): string | undefined {
  switch (holidayType) {
    case 'Family friendly':
      return 'holidayType.familyFriendly'
    case 'Honeymoon':
    case 'Adults only':
    case 'Romantic':
      return 'holidayType.couples'
    default:
      return undefined
  }
}
